export function useErrorHelper() {
  // Forms.
  const errors = ref<{ [key: string]: string[] } | null>(null)

  function getError(key: string): string | undefined {
    if (errors.value && errors.value[key] && errors.value[key][0]) {
      return errors.value[key][0]
    }
    return undefined
  }

  function setErrors(newErrors: { [key: string]: string[] } | null): void {
    errors.value = newErrors
  }

  function hasError(key: string): boolean {
    if (errors.value && errors.value[key] && errors.value[key][0]) {
      return true
    }
    return false
  }

  function resetErrors(): void {
    errors.value = null
  }

  return { errors, getError, setErrors, hasError, resetErrors }
}
